@let formMode = editModel.state.roleFormMode();

<form class="form flex--col gap-24" [formGroup]="editModel.form">
  @if (formMode !== TYPES.RoleFormMode.View) {
    <div class="flex gap-24">
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'roles.form.role-name' | translate }}
          <span class="required">*</span>
        </div>
        <input
          class="h--40"
          pInputText
          formControlName="name"
          placeholder="{{ 'roles.form.role-placeholder' | translate }}"
          type="text"
        />
      </div>
      <div class="col">
        <div class="label mb-8 text-14 fw-500">
          {{ 'roles.form.description' | translate }}
        </div>
        <input
          class="h--40"
          pInputText
          formControlName="description"
          placeholder="{{ 'roles.form.description-placeholder' | translate }}"
          type="text"
        />
      </div>
    </div>
  }

  <div class="table-wrapper scrollbar-gray">
    <p-table
      formGroupName="permissions"
      class="table-primary no-wrap-cols retain-br"
      [rowHover]="true"
      [value]="editModel.state.visibleResources()"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="text">
            <div class="column-wrapper">
              <div class="label-wrapper text-14 fw-500 color-gray-900">
                {{ 'roles.grid.resource' | translate }}
              </div>
            </div>
          </th>
          @for (action of listModel.allowedActions; track action) {
            <th class="text">
              <div class="column-wrapper flex gap-8">
                @let iconsMap = editModel.state.headerCheckboxIcons();
                @if (iconsMap) {
                  <p-checkbox
                    [class]="'custom-disabled-color'"
                    [disabled]="formMode === TYPES.RoleFormMode.View"
                    [binary]="true"
                    [inputId]="action"
                    [ngModelOptions]="{ standalone: true }"
                    [ngModel]="!!iconsMap.get(action)"
                    [checkboxIcon]="iconsMap.get(action)"
                    [readonly]="true"
                    (click)="editModel.toggleColumn(action)"
                  ></p-checkbox>
                }

                <label class="label-wrapper clickable text-14 fw-600" [for]="action">
                  {{ 'roles.actions.' + action | translate }}
                </label>
              </div>
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-resource>
        <tr>
          <td class="text text text-14 fw-400 color-gray-900">
            {{ 'roles.resources.' + resource | translate }}
          </td>

          @for (action of listModel.allowedActions; track action) {
            <td class="text">
              @let permissions = editModel.resourcePermissions(resource);

              @if (editModel.isActionAllowed(resource, action) && permissions !== undefined) {
                <p-checkbox
                  [class]="'custom-disabled-color'"
                  [ngModelOptions]="{ standalone: true }"
                  [ngModel]="permissions.includes(action)"
                  [binary]="true"
                  [disabled]="
                    editModel.isActionLocked(resource, action) ||
                    formMode === TYPES.RoleFormMode.View
                  "
                  (ngModelChange)="editModel.calculateResourceActions(resource, action, $event)"
                  name="groupname"
                ></p-checkbox>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</form>
